var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 27.875C34.6082 28.3582 34.6082 29.1418 34.125 29.625C33.6418 30.1082 32.8582 30.1082 32.375 29.625L30 27.25V36.25C30 36.9404 29.4404 37.5 28.75 37.5C28.0596 37.5 27.5 36.9404 27.5 36.25V27.25L25.125 29.625C24.6418 30.1082 23.8582 30.1082 23.375 29.625C22.8918 29.1418 22.8918 28.3582 23.375 27.875L28.75 22.5L34.125 27.875Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9108 36.4787C19.542 37.0487 18.7883 37.2248 18.2052 36.8771L6.25 29.75C5.5 29.25 5 28.5 5 27.625V12.375C5 11.5 5.5 10.625 6.25 10.25L18.75 2.875C19.125 2.625 19.5 2.5 20 2.5C20.5 2.5 20.875 2.625 21.25 2.875L33.75 10.25C34.5 10.75 35 11.5 35 12.375V18.75C35 19.4404 34.4404 20 33.75 20C33.0596 20 32.5 19.4404 32.5 18.75V12.375L20 5L7.5 12.375V27.625L19.493 34.7066C20.1105 35.0712 20.3004 35.8766 19.9108 36.4787Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/Request.788513bb498fca2151252acfa393a637.svg";
export { ForwardRef as ReactComponent };